/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyResourceRecommendationStatusQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyResourceRecommendationStatusQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyResourceRecommendationStatusQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyResourceRecommendationStatusQueryOperator>): PolicyResourceRecommendationStatusQueryOperator {
        let obj = Object.assign(new PolicyResourceRecommendationStatusQueryOperator(), model);
        PolicyResourceRecommendationStatusQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyResourceRecommendationStatusQueryOperator>): PolicyResourceRecommendationStatusQueryOperator {
        if (!model) return null;
        return PolicyResourceRecommendationStatusQueryOperator.newInstance(<PolicyResourceRecommendationStatusQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyResourceRecommendationStatusQueryOperator) {
        if (!obj) return;

        models.PolicyResourceRecommendationStatusQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyResourceRecommendationStatusQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyResourceRecommendationStatusQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy resource recommendation statuses to include
     */
    statuses: Array<models.PolicyResourceRecommendationStatus>;

}
